import { render, staticRenderFns } from "./VideoControlBar.vue?vue&type=template&id=1e7809b3&scoped=true"
import script from "./VideoControlBar.vue?vue&type=script&lang=js"
export * from "./VideoControlBar.vue?vue&type=script&lang=js"
import style0 from "./VideoControlBar.vue?vue&type=style&index=0&id=1e7809b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7809b3",
  null
  
)

export default component.exports